import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  Switch,
  FormControlLabel,
  SelectProps,
  FormControlProps,
  SwitchProps,
  FormControlLabelProps,
} from '@mui/material';

export const StyledFormControl: React.FC<FormControlProps> = (props) => (
  <FormControl
    {...props}
    sx={{
      '& .MuiInputLabel-root': {
        fontWeight: 600,
        fontSize: '1rem',
        color: 'rgba(0, 0, 0, 0.87)',
        '&.Mui-focused': {
          color: '#e72f0d',
          fontWeight: 600,
        },
        '&.Mui-error': {
          color: '#d32f2f',
        },
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
        backgroundColor: 'white',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#000000',
          borderWidth: 2,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#333333',
          borderWidth: 2,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#e72f0d',
          borderWidth: 2,
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: '#d32f2f',
          borderWidth: 2,
        },
      },
      '& .MuiSelect-select': {
        padding: '16px 14px',
        fontSize: '1rem',
      },
      '& .MuiFormHelperText-root': {
        marginLeft: 2,
        marginTop: 1,
        fontSize: '0.8rem',
        fontWeight: 500,
      },
      ...props.sx,
    }}
  />
);

export const StyledSelect: React.FC<SelectProps> = (props) => (
  <Select
    {...props}
    sx={{
      borderRadius: 2,
      backgroundColor: 'white',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
        borderWidth: 2,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#333333',
        borderWidth: 2,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e72f0d',
        borderWidth: 2,
      },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d32f2f',
        borderWidth: 2,
      },
      '& .MuiSelect-select': {
        padding: '16px 14px',
        fontSize: '1rem',
      },
      ...props.sx,
    }}
  />
);

export const StyledFormControlLabel: React.FC<FormControlLabelProps> = (props) => (
  <FormControlLabel
    {...props}
    sx={{
      '& .MuiFormControlLabel-label': {
        fontSize: '1rem',
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.87)',
      },
      '& .MuiSwitch-root': {
        '& .MuiSwitch-switchBase': {
          '&.Mui-checked': {
            color: '#e72f0d',
            '& + .MuiSwitch-track': {
              backgroundColor: '#e72f0d',
            },
          },
        },
        '& .MuiSwitch-track': {
          backgroundColor: 'rgba(0, 0, 0, 0.38)',
        },
      },
      ...props.sx,
    }}
  />
);

export const StyledSwitch: React.FC<SwitchProps> = (props) => (
  <Switch
    {...props}
    sx={{
      '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
          color: '#e72f0d',
          '& + .MuiSwitch-track': {
            backgroundColor: '#e72f0d',
          },
        },
      },
      '& .MuiSwitch-track': {
        backgroundColor: 'rgba(0, 0, 0, 0.38)',
      },
      ...props.sx,
    }}
  />
);